<template>
  <div class="insta-posts-section">
    <div class="insta-posts-header reveal">
      <div>
        <span class="section-eyebrow">Real People. Real Pairs.</span>
        <h2 class="insta-posts-title">Our Customers</h2>
      </div>
      <p class="insta-posts-sub">
        10,000+ happy pairs and counting. Tag us
        <span class="insta-tag-handle">@HooligansEyewear</span>
      </p>
    </div>
    <div class="insta-posts-grid">
      <div
        v-for="(post, idx) in posts"
        :key="post.username"
        class="ig-card reveal"
        :class="{
          'reveal-delay-1': idx === 1,
          'reveal-delay-2': idx === 2,
        }"
      >
        <div class="ig-card-header">
          <div class="ig-avatar" :class="post.avatarClass">
            {{ post.initials }}
          </div>
          <div>
            <div class="ig-username">{{ post.username }}</div>
            <div class="ig-location">{{ post.location }}</div>
          </div>
          <svg class="ig-header-icon" viewBox="0 0 24 24" fill="none">
            <rect
              x="2"
              y="2"
              width="20"
              height="20"
              rx="5"
              stroke="#000"
              stroke-width="1.5"
            />
            <circle cx="12" cy="12" r="4" stroke="#000" stroke-width="1.5" />
            <circle cx="17.5" cy="6.5" r="1" fill="#000" />
          </svg>
        </div>
        <a
          :href="post.permalink"
          target="_blank"
          rel="noopener"
          class="ig-card-img-link"
        >
          <MediaSlotImage
            :slot-code="'about.customer_' + (idx + 1)"
            :fallback="post.img"
            image-class="ig-card-img"
            :image-style="post.imgStyle"
            :alt="'Customer photo — ' + post.username"
            sizes="(max-width: 767px) 90vw, 320px"
            :width="720"
            :height="960"
            loading="lazy"
          />
        </a>
        <div class="ig-card-actions">
          <button
            type="button"
            class="ig-action-btn"
            :class="{ 'is-liked': isLiked(post.username) }"
            :aria-pressed="isLiked(post.username) ? 'true' : 'false'"
            :aria-label="
              isLiked(post.username)
                ? 'Unlike post by ' + post.username
                : 'Like post by ' + post.username
            "
            @click="toggleLike(post.username)"
          >
            <svg
              viewBox="0 0 24 24"
              :fill="isLiked(post.username) ? '#e0245e' : 'none'"
              :stroke="isLiked(post.username) ? '#e0245e' : '#000'"
              stroke-width="1.8"
              aria-hidden="true"
            >
              <path
                d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
              />
            </svg>
          </button>
          <a
            :href="post.permalink"
            target="_blank"
            rel="noopener"
            class="ig-action-btn"
            :aria-label="'Comment on post by ' + post.username"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000"
              stroke-width="1.8"
              aria-hidden="true"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
          </a>
          <button
            type="button"
            class="ig-action-btn ig-action-bookmark"
            aria-label="Save post"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000"
              stroke-width="1.8"
              aria-hidden="true"
            >
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
            </svg>
          </button>
        </div>
        <div class="ig-likes">{{ likesText(post) }}</div>
        <div class="ig-caption">
          <strong>{{ post.username }}</strong> {{ post.caption }}
          <span v-for="tag in post.tags" :key="tag" class="ig-tag">{{
            tag
          }}</span>
        </div>
        <div class="ig-time">{{ post.time }}</div>
      </div>

      <!-- Follow CTA -->
      <div class="ig-card ig-card-cta reveal reveal-delay-3">
        <svg
          class="ig-cta-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(255,170,77,0.9)"
          stroke-width="1.3"
          aria-hidden="true"
        >
          <rect x="2" y="2" width="20" height="20" rx="5" />
          <circle cx="12" cy="12" r="4" />
          <circle
            cx="17.5"
            cy="6.5"
            r="1.2"
            fill="rgba(255,170,77,0.9)"
            stroke="none"
          />
        </svg>
        <p class="ig-cta-handle">@HooligansEyewear</p>
        <p class="ig-cta-sub">Tag us in your photos and get featured here</p>
        <a
          href="https://instagram.com/HooligansEyewear"
          target="_blank"
          rel="noopener"
          class="ig-cta-link"
          >Follow on Instagram</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "AboutCustomers",
  components: { MediaSlotImage },
  props: {
    posts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      liked: {},
    };
  },
  methods: {
    isLiked(username) {
      return !!this.liked[username];
    },
    likesText(post) {
      const bumped = post.likes + (this.isLiked(post.username) ? 1 : 0);
      return bumped.toLocaleString("en-US") + " likes";
    },
    toggleLike(username) {
      this.liked = {
        ...this.liked,
        [username]: !this.liked[username],
      };
    },
  },
};
</script>
